import _ from 'lodash'
import Backbone from 'backbone'
import template from './web-address-form.hbs'
import FormView from 'scoreboard/components/form-view'
import formHelper from 'scoreboard/components/form-helper'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import urlValidator from 'scoreboard/components/validators/url-validator'
import httpsValidator from 'scoreboard/components/validators/https-validator'
import i18n from 'scoreboard/components/i18n'

var WebAddressForm = Backbone.View.extend({

	// this.model is a RelatedItem

	tagName: 'form',

	className: 'web-address-form',

	events: {
		'click .cancel': 'cancel'
	},

	/**
	 * @param {String} [options.header]
	 *
	 * @param {String} [options.primaryButtonLabel='Save']
	 *
	 * @param {String} [options.httpsValidator=false] Pass true if url must be https://
	 * The default it so apply the urlValidator (to maintain backwards compatibility)
	 *
	 * @param {String} [options.label] The web address label text
	 *
	 * @param {String} [options.url] The web address url
	 */
	initialize: function(options = {}) {
		this.options = options
		this.primaryButtonLabel = options.primaryButtonLabel || i18n.get('common.save')
		this._markedFields = []
		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this),
			guard: false
		})
	},

	render: function() {
		this.$el.html(template({
			header: this.options.header,
			primaryButtonLabel: this.primaryButtonLabel
		}))

		// setup input validation
		this._markedFields.push(new MarkedField({
			el: this.$('.label'),
			validator: requiredValidator
		}).render())
		this._markedFields.push(new MarkedField({
			el: this.$('.url'),
			validator: [requiredValidator,
				this.options.httpsValidator ? httpsValidator : urlValidator]
		}).render())

		const {label, url} = this.options
		formHelper.writeToDom({label, url}, this.el)

		this.formView.start()

		return this
	},

	submit: function(e) {
		this.trigger('submit', {
			label: this.$('.label').val(),
			url: this.$('.url').val()
		})
	},

	cancel: function() {
		this.trigger('cancel')
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap(this._markedFields, 'remove')
	}

})

export default WebAddressForm

WebAddressForm.__filename__ = 'components/web-address-form.js'
